<template>
  <section
    :key="'block-front'"
    :data-background-image="'/media/background-' + mode + '-' + variant + '.jpg'"
    :data-background-size="size"
    :data-background-position="position"
    :data-background-repeat="repeat"
    :data-background-opacity="opacity"
  >
    <slot></slot>
  </section>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: "center"
    },
    variant: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: "cover"
    },
    position: {
      type: String,
      default: "center"
    },
    repeat: {
      type: String,
      default: "no-repeat"
    },
    opacity: {
      type: Number,
      default: 1
    }
  }
};
</script>